import { TEXTINPUT_BLOCKED_CHARACTERS } from 'Constants/constants'

import { DEFAULT_TAG_COLOR, MAX_TAG_NAME_LENGTH } from './tagging.constants'
import type { TagColor } from './tagging.types'
import type { TaggingState } from './TaggingProvider.types'

export type TaggingAction =
  | { type: 'ENTER_EDIT_MODE'; payload: { rowId: string } }
  | { type: 'EXIT_EDIT_MODE' }
  | { type: 'SET_INPUT_TEXT'; payload: { text: string } }
  | { type: 'SET_SELECTED_COLOR'; payload: { color: TagColor } }
  | { type: 'SET_ACTIVE_EDITOR_ROW_ID'; payload: { rowId: string | null } }

export const INITIAL_STATE: TaggingState = {
  activeEditorRowId: null,
  inputText: '',
  mode: 'read',
  selectedColor: DEFAULT_TAG_COLOR,
  triggerRowId: null,
}

export const taggingReducer = (
  state: TaggingState,
  action: TaggingAction,
): TaggingState => {
  switch (action.type) {
    case 'ENTER_EDIT_MODE': {
      if (state.mode === 'edit') {
        return state
      }

      return {
        ...state,
        activeEditorRowId: action.payload.rowId,
        inputText: '',
        mode: 'edit',
        selectedColor: DEFAULT_TAG_COLOR,
        triggerRowId: action.payload.rowId,
      }
    }

    case 'EXIT_EDIT_MODE': {
      return {
        ...state,
        activeEditorRowId: null,
        inputText: '',
        mode: 'read',
        selectedColor: DEFAULT_TAG_COLOR,
        triggerRowId: null,
      }
    }

    case 'SET_INPUT_TEXT': {
      return {
        ...state,
        inputText: action.payload.text
          .toLowerCase()
          .replaceAll(/[\r\n\t]/g, '')
          .replaceAll(TEXTINPUT_BLOCKED_CHARACTERS, '')
          .slice(0, MAX_TAG_NAME_LENGTH),
      }
    }

    case 'SET_SELECTED_COLOR': {
      return {
        ...state,
        selectedColor: action.payload.color,
      }
    }

    case 'SET_ACTIVE_EDITOR_ROW_ID': {
      const { rowId } = action.payload

      return {
        ...state,
        activeEditorRowId: rowId,
        ...(rowId && !state.activeEditorRowId
          ? { inputText: '', selectedColor: DEFAULT_TAG_COLOR }
          : {}),
      }
    }

    default: {
      return state
    }
  }
}
